import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export interface OrderFilterValues {
  os: string[];
  states: string[];
}

export default function useOrderFilterValues(selectedProjects?: string) {
  const axios = useAxios();

  return useQuery<OrderFilterValues>({
    queryKey: [EQueryKeys.ORDER_FILTER_VALUES, selectedProjects],
    queryFn: async () => {
      const response = await axios.get(
        getApiRouteOrMock(EApiRoutes.ORDER_FILTER_VALUES),
        undefined,
        selectedProjects ? { 'x-publishers': selectedProjects } : undefined
      );

      return {
        os: response?.os ?? [],
        states: response?.states ?? []
      };
    },
    enabled: !!selectedProjects,
    refetchOnWindowFocus: false,
    retry: false
  });
}
